import { ShieldCheck } from "@phosphor-icons/react";

const COL = { green: "#00A86B", amber: "#FFB020", red: "#E63946", grey: "#6b7280" };

const Juris = ({ code, data, color }) => (
  <div className="flex items-center justify-between text-sm py-1.5" data-testid={`score-juris-${code}`}>
    <span className="flex items-center gap-2">
      <span className="text-[9px] font-bold px-1.5 py-0.5 rounded" style={{ background: `${color}22`, color }}>{code}</span>
      <span className="text-white/70">{data.tracked} deadline{data.tracked === 1 ? "" : "s"} tracked</span>
    </span>
    <span className="text-xs font-semibold" style={{ color: data.overdue ? COL.red : COL.green }}>
      {data.overdue ? `${data.overdue} overdue` : "all clear"}
    </span>
  </div>
);

/**
 * Investor-facing IE+UK compliance health score. RAG ring + jurisdiction breakdown.
 * `health` shape: { configured, score, rag, label, overdue, due_soon, ie:{overdue,tracked}, uk:{...}, uk_enabled }
 */
export const ComplianceScoreBadge = ({ health }) => {
  if (!health || !health.configured || health.score == null) {
    return (
      <div className="glass rounded-2xl p-6 flex items-center gap-4" data-testid="compliance-score-badge">
        <ShieldCheck size={28} weight="duotone" className="text-white/40" />
        <div>
          <div className="font-display">Compliance health</div>
          <div className="text-white/50 text-sm">Company profile not set up yet.</div>
        </div>
      </div>
    );
  }
  const c = COL[health.rag] || COL.grey;
  const r = 34, circ = 2 * Math.PI * r;
  const dash = (health.score / 100) * circ;

  return (
    <div className="glass rounded-2xl p-6" data-testid="compliance-score-badge">
      <div className="flex items-center gap-5">
        <div className="relative shrink-0" style={{ width: 84, height: 84 }}>
          <svg width="84" height="84" viewBox="0 0 84 84">
            <circle cx="42" cy="42" r={r} fill="none" stroke="rgba(255,255,255,0.08)" strokeWidth="7" />
            <circle cx="42" cy="42" r={r} fill="none" stroke={c} strokeWidth="7" strokeLinecap="round"
              strokeDasharray={`${dash} ${circ}`} transform="rotate(-90 42 42)" />
          </svg>
          <div className="absolute inset-0 flex flex-col items-center justify-center">
            <span className="mono text-2xl font-bold" style={{ color: c }} data-testid="score-value">{health.score}</span>
          </div>
        </div>
        <div className="min-w-0">
          <div className="flex items-center gap-2">
            <ShieldCheck size={18} weight="fill" style={{ color: c }} />
            <span className="font-display text-lg">Compliance health</span>
          </div>
          <div className="text-sm font-semibold mt-0.5" style={{ color: c }} data-testid="score-label">
            {health.label}{health.uk_enabled ? " · Ireland & UK" : " · Ireland"}
          </div>
          <p className="text-xs text-white/45 mt-1">Live score across all statutory filing deadlines.</p>
        </div>
      </div>
      <div className="mt-4 pt-3 border-t border-white/5">
        <Juris code="IE" data={health.ie} color={COL.green} />
        {health.uk_enabled && <Juris code="UK" data={health.uk} color="#5B8DEF" />}
      </div>
    </div>
  );
};
